import { PUBLIC_ROUTES } from '../../constants/routes/public';

export const setPseudoUrl = slug => {
  const baseRoutes = Object.values(PUBLIC_ROUTES).map(route => route.path);

  if (!window.location.pathname.includes(slug)) {
    // Проверяем точное совпадение или соответствие шаблону с параметрами
    const isRouteMatch = baseRoutes.some(route => {
      if (route === window.location.pathname) return true;

      // Преобразуем шаблонный путь в регулярное выражение
      if (route.includes(':')) {
        const regexPattern = route.replace(/:\w+/g, '[^/]+');
        const regex = new RegExp(`^${regexPattern}$`);
        return regex.test(window.location.pathname);
      }

      return false;
    });

    if (isRouteMatch) {
      window.history.pushState({ baseUrl: window.location.pathname }, '', slug);
      return;
    }
    window.history.pushState({ prevUrl: window.location.pathname, baseUrl: window.history.state?.baseUrl }, '', slug);
  }
};
